// extracted by mini-css-extract-plugin
export default {"container":"EventPreview_container__CcQ8i"};